import React from 'react';
import i18n from "i18next";
import { NavLink } from 'react-router-dom';
import { useTranslation } from "react-i18next";

export const Layout = ({ children }) => {
  const { t } = useTranslation();
  return (
    <>
      <header className="bg-gray-800 text-white">
        <nav className="container mx-auto px-4 py-4">
          <ul className="flex space-x-4">
            <li>
              <NavLink
                to={`/${i18n.language}/home`}
                className={({ isActive }) =>
                  isActive ? 'text-blue-400' : 'text-white'
                }
              >
                {t('home')}
              </NavLink>
            </li>
            <li>
              <NavLink
                to={`/${i18n.language}/search`}
                className={({ isActive }) =>
                  isActive ? 'text-blue-400' : 'text-white'
                }
              >
                {t('search_profile')}
              </NavLink>
            </li>
            <li>
              <NavLink
                to={`/${i18n.language}/faq`}
                className={({ isActive }) =>
                  isActive ? 'text-blue-400' : 'text-white'
                }
              >
                {t('faq')}
              </NavLink>
            </li>
            <li>
              <NavLink
                to={`/${i18n.language}/smartplus`}
                className={({ isActive }) =>
                  isActive ? 'text-blue-400' : 'text-white'
                }
              >
                {t('decoded_ponzi')}
              </NavLink>
            </li>
          </ul>
        </nav>
      </header>
      <main className="flex-grow container mx-auto px-4 py-8">
        {children}
      </main>
    </>
  );
}
